import AhoyTracker from 'shared/ahoy_tracker';
const Cookies = require('js-cookie');

export default class LivestreamingBanner {
  constructor(options) {
    this.element = options.element;
    this.playerWrapper = document.querySelector('.js-player-wrapper');
    this.body = document.querySelector('body');
    this.ahoy = new AhoyTracker(this.element);
    this.platform = 'web';
    this.initBannerRetryCounter = 0;
    this.imgPlaceHolder = this.element.querySelector('img')
  }

  init() {
    this.initBannerBasedOnSchedule();
  }

  initBannerBasedOnSchedule() {
    let scheduleUrl = this.element.dataset.scheduleUrl;

    if (!scheduleUrl) {
      return;
    }
    $.ajax({
      method: 'GET',
      url: scheduleUrl,
      dataType: 'json',
    })
    .done(this.processSchedule.bind(this))
    .fail(this.failedSchedule.bind(this));
  }

  processSchedule(response) {
    let result = this.filterCurrentAndFutureBanners(response);
    this.executeFilteredSchedule(result.currentBanners, result.futureBanners);
  }

  executeFilteredSchedule(currentBanners, futureBanners) {
    let thisAlias = this;
    if (currentBanners.length > 0 ) {
      this.initLivestreamingBanner(currentBanners[0]);
    }
    futureBanners.forEach(function(schedule) {
      let showTimeout = new Date(schedule.bannerShowTime) - new Date();
      setTimeout(thisAlias.initLivestreamingBanner.bind(thisAlias, schedule), showTimeout);
    });
  }

  filterCurrentAndFutureBanners(response) {
    let schedules = response.schedules;
    let dateNow = this.getCurrentTime();
    let currentBanners = schedules.filter(function(schedule) {
      return new Date(schedule.bannerShowTime) < dateNow && new Date(schedule.bannerHideTime) > dateNow;
    });

    let futureBanners = schedules.filter(function(schedule) {
      return new Date(schedule.bannerShowTime) > dateNow;
    });

    return { currentBanners, futureBanners };
  }

  initLivestreamingBanner(bannerSchedule) {
    this.loadBlockingBanner();
    this.unhideLivestreamingBanner();
    this.sendAhoyEvent('impression');

    let hideTimeout = new Date(bannerSchedule.bannerHideTime) - this.getCurrentTime();
    setTimeout(this.hideLivestreamingBanner.bind(this), hideTimeout);
  }

  loadBlockingBanner() {
    var backgroundUrl = this.element.dataset.bannerBackgroundUrl;
    this.imgPlaceHolder.src=backgroundUrl
  }

  getCurrentTime() {
    return new Date();
  }

  failedSchedule() {
    if (this.initBannerRetryCounter >= 3) {
      window.console.error(`failed to fetch schedule after ${this.initBannerRetryCounter} attempts`);
      return;
    }

    var initBannerTimeout = [5000, 10000, 20000][this.initBannerRetryCounter];
    setTimeout(this.initBannerBasedOnSchedule.bind(this), initBannerTimeout);
    this.initBannerRetryCounter++;
  }

  hideLivestreamingBanner() {
    this.element.classList.add('hidden');
  }

  unhideLivestreamingBanner() {
    this.element.classList.remove('hidden');
  }

  sendAhoyEvent(action) {
    this.ahoy.sendEvent(JSON.stringify({action:action}));
  }

  getScreen() {
    return window.screen;
  }

  getWindow() {
    return window;
  }

  getPlatform() {
    return this.platform;
  }

  getVisitorId() {
    return Cookies.get('ahoy_visitor');
  }

  getUUID() {
    return window.ahoy.uuid;
  }

  getContentId() {
    let ahoyProps = JSON.parse(this.element.dataset.ahoyProps);
    return ahoyProps.content_id;
  }

  getContentType() {
    let ahoyProps = JSON.parse(this.element.dataset.ahoyProps);
    return ahoyProps.content_type;
  }
}
